(function () {
    'use strict';

    function CustomerStatisticsComponentController($scope, $state, CustomerCustom, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;


        loadPage();

        function loadPage() {
            translatePartialLoader.addPart('customerStatistics');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
        }


        $scope.$watch('$ctrl.selectedCustomerId', function () {
            if ($ctrl.selectedCustomerId) {
                loadCustomerStatistics();
            }
        })


        function loadCustomerStatistics() {
            $ctrl.customerStatisticsObject = CustomerCustom.getCustomerStatistics($ctrl.selectedCustomerId).query();
            console.log($ctrl.customerStatisticsObject);
        }

    }

    var CustomerStatisticsComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-statistics/partial-form.customer-statistics.html',
        controller: CustomerStatisticsComponentController,
        bindings:
            {
                selectedCustomerId: '<',
            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerStatistics', CustomerStatisticsComponent)

    CustomerStatisticsComponentController.$inject = ['$scope', '$state', 'CustomerCustom', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams'];


})();

